import { Injectable } from '@angular/core';
import { LoadingController, Loading, ToastController, LoadingOptions, AlertController, Platform } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { SafariViewController } from '@ionic-native/safari-view-controller';
import { ENV } from '../../env/environment';

@Injectable()
export class UtiltiyProvider {
  loading: Loading;
  constructor(private safariViewController: SafariViewController,public platform: Platform,private loadingCtrl: LoadingController, private toastCtrl: ToastController, private storage: Storage, private alertCtrl: AlertController) {

  }

  startLoading() {
    this.loading = this.loadingCtrl.create({
      spinner: 'crescent',
      cssClass: 'loader'
    });
    this.loading.present();
  }
  // For stopLoading
  stopLoading() {
    this.loading.dismiss().catch(() => this.loading.dismiss());
  }

  // show toast
  toaster(text) {
    const toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  // For set data inside the local Storage
  setStorage(key, value) {
    this.storage.set(key, value);

  }
  // For get data from local Storage
  async getStorage(key) {
    return this.storage.get(key).then((val) => {
      return val
    })
  }

  removeStorage(key) {
    this.storage.remove(key);
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }


  async showDialog() {
    return new Promise(async (resolve) => {

      const confirm = await this.alertCtrl.create({
        title: 'Delete',
        message: 'Do you want to delete this record',
        buttons: [
          {
            text: 'No',
            handler: () => {
              console.log('Disagree clicked');
              return resolve(false);

            }
          },
          {
            text: 'Yes',
            handler: () => {
              console.log('Agree clicked');
              return resolve(true);

            }
          }
        ]
      });
      await confirm.present();
    });
  }

  async attentionDialog(options) {
    return new Promise(async (resolve) => {

      const confirm = await this.alertCtrl.create({
        title: options.title,
        message: options.message,
        buttons: [
          {
            text: options.approveText,
            cssClass: 'approveCss',
            handler: () => {
              console.log('Agree clicked');
              return resolve(true);
              
            }
          },
          {
            text: options.rejectText,
            cssClass: 'rejectCss',
            handler: () => {
              console.log('Disagree clicked');
              return resolve(false);
  
            }
          },
        ]
      });
      await confirm.present();
    });
  }

  async fleetDialog(options) {
    return new Promise(async (resolve) => {

      const confirm = await this.alertCtrl.create({
        title: options.title,
        inputs: options.data,
        buttons: [
          {
            text: "OK",
            cssClass: 'approveCss',
            handler: data => {
              console.log('OK clicked. Data -> ' + JSON.stringify(data));
              return resolve(data);
              }

          },
          {
            text: "Cancel",
            cssClass: 'rejectCss',
            handler: () => {
              console.log('Disagree clicked');
              return resolve(false);
  
            }
          },
        ]
      });
      await confirm.present();
    });
  }

  async inputDialog(options) {
    return new Promise(async (resolve) => {

      const confirm = await this.alertCtrl.create({
        enableBackdropDismiss: false ,
        title: options.title,
        inputs: [
          {
            name: 'comments',
            placeholder: 'Comment'
          },
        ],
        buttons: [
          {
            text: options.approveText,
            handler: (data) => {
              console.log('Agree clicked',data.comments);
              if(data.comments.length == 0){
                this.toaster("Comment required");
                return false;
              }else{
                return resolve(data.comments);
              }
              
            }
          },
          
        ]
      });
      await confirm.present();
    });
  }
  
  async commonInputDialog(options) {
    return new Promise(async (resolve) => {

      const confirm = await this.alertCtrl.create({
        enableBackdropDismiss: false ,
        title: options.title,
        inputs: [
          {
            name: options.key,
            placeholder: options.title
          },
        ],
        buttons: [
          {
            text: "Cancel",
            handler: (data) => {
                return resolve(null);
            }
          },
          {
            text: options.approveText,
            handler: (data) => {
              let key = options.key;
              console.log('Agree clicked',data[key]);
              if(data[key].length == 0){
                this.toaster(options.title+" required");
                return false;
              }else{
                let valid = isNaN(data[key])
                if(valid){
                  this.toaster("Invalid number");
                  return false;
                }
                let number = parseFloat(data[key]);
                console.log("number",number);
                return resolve(number);
              }
              
            }
          },
          
        ]
      });
      await confirm.present();
    });
  }
 
  async commentInputDialog(options) {
    return new Promise(async (resolve) => {

      const confirm = await this.alertCtrl.create({
        enableBackdropDismiss: false ,
        title: options.title,
        inputs: [
          {
            name: options.key,
            placeholder: options.title,
            value:options.data
          },
        ],
        buttons: [
          {
            text: "Cancel",
            handler: (data) => {
                return resolve(null);
            }
          },
          {
            text: options.approveText,
            handler: (data) => {
              let key = options.key;
              console.log('Agree clicked',data[key]);
              if(data[key].length == 0){
                this.toaster(options.title+" required");
                return false;
              }else{
                
                return resolve(data[key]);
              }
              
            }
          },
          
        ]
      });
      await confirm.present();
    });
  }

  async getPagePermission(pageIdentity){
    let status = false;
    let permissions = await this.getStorage("permissions");
    if (permissions) {
      permissions = JSON.parse(permissions);
    }
 
    if (permissions.hasOwnProperty(pageIdentity)) {
      status = true;
    }
    return status;
  }

  async appUpdateDialog(options) {
    return new Promise(async (resolve) => {

      const confirm = await this.alertCtrl.create({
        enableBackdropDismiss: false,
        title: options.title,
        message: options.message,
        buttons: [
          {
            text: options.approveText,
            cssClass: 'approveCss',
            handler: () => {
              console.log('Agree clicked');
              return resolve(true);
              
            }
          },
        ]
      });
      await confirm.present();
    });
  }

  async openPdf(url){
    let pdfUrl = ENV.DEV_URL+url
    if (this.platform.is('android')) {
      window.open(pdfUrl,"_system");
    }else if(this.platform.is('ios')){
      this.safariViewController.isAvailable()
.then((available: boolean) => {
    if (available) {

      this.safariViewController.show({
        url: pdfUrl,
        hidden: false,
        animated: false,
        transition: 'curl',
        enterReaderModeIfAvailable: true,
        tintColor: '#ff0000'
      })
      .subscribe((result: any) => {
          if(result.event === 'opened') console.log('Opened');
          else if(result.event === 'loaded') console.log('Loaded');
          else if(result.event === 'closed') console.log('Closed');
        },(error: any) => console.error(error))
        
      }}
    );
      
    }
     else if(this.platform.is('mobileweb') || this.platform.is('core')) {
      window.open(pdfUrl,"_system");
    }
  }


}



// WEBPACK FOOTER //
// ./src/providers/utiltiy/utiltiy.ts